import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "field", "rows", "template"]

  open(event) {
    event.preventDefault()
    this.dialogTarget.classList.remove("hidden")
    this.dialogTarget.classList.add("flex")
    if (this.hasFieldTarget) this.fieldTarget.focus()
    this.dispatch("open")
  }

  close(event) {
    if (event) event.preventDefault()
    if (!this.hasDialogTarget) return
    this.dialogTarget.classList.add("hidden")
    this.dialogTarget.classList.remove("flex")
    this.dispatch("close")
  }

  backdrop(event) {
    if (event.target === this.dialogTarget) this.close()
  }

  keydown(event) {
    if (event.key === "Escape") this.close()
  }

  submit(event) {
    const email = this.hasFieldTarget ? this.fieldTarget.value.trim() : ""
    if (!email) return

    this.close()
    this.showPlaceholder(email)

    const button = event.target.querySelector("[type=submit]")
    if (button) {
      button.disabled = true
      button.value = "Drafting…"
    }
  }

  showPlaceholder(email) {
    if (!this.hasRowsTarget || !this.hasTemplateTarget) return

    const row = this.templateTarget.content.firstElementChild.cloneNode(true)
    const label = row.querySelector("[data-placeholder-email]")
    if (label) label.textContent = email
    this.rowsTarget.prepend(row)
  }
}
